import mutations from "./mutations";
import actions from "./actions";

export default {
  state: {
    carList: [],
    nextPage: "",
    currentPage: 1
  },
  mutations,
  actions
};
